export default __webpack_public_path__ + "static/media/selfInflected.d9f0335c.svg";